import {
  Component,
  Inject,
  OnInit,
  PLATFORM_ID,
  ChangeDetectionStrategy,
} from "@angular/core";
import { LayoutComponent } from "./shared/layout/layout.component";
import { isPlatformBrowser } from "@angular/common";
import { SubscriptionService } from "./shared/services/subscription.service";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs";
import { SeoService } from "./shared/seo/seo.service";
import { GclidService } from "./shared/services/gclid.service";
import { SignupSourceService } from "./shared/services/signup-source.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [LayoutComponent],
})
export class AppComponent implements OnInit {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private subscriptionService: SubscriptionService,
    private router: Router,
    private seoService: SeoService,
    private gclidService: GclidService,
    private signupSourceService: SignupSourceService
  ) {}

  ngOnInit() {
    this.seoService.init();

    this.subscriptionService.init().subscribe({});

    // Scroll to top on navigation — guarded so it only runs in the browser
    // (window is not defined in the SSR/prerender environment).
    if (isPlatformBrowser(this.platformId)) {
      this.gclidService.capture();
      this.signupSourceService.capture();

      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe(() => {
          window.scrollTo(0, 0);
        });
    }
  }
}
